import React from "react"

const PJMFooterLogo = () => {
  return (
    <svg
      id="PJM_logo"
      data-name="PJM logo"
      xmlns="http://www.w3.org/2000/svg"
      width="110"
      height="38"
      viewBox="0 0 110 38"
    >
      <defs>
        <clipPath id="clip-path">
          <path
            id="Clip_12"
            data-name="Clip 12"
            d="M0,0H3.281V3.186H0Z"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Group_14" data-name="Group 14" transform="translate(0 0)">
        <path
          id="Fill_1"
          data-name="Fill 1"
          d="M5.476,29.439H0V.355H5.476V2.53a10.622,10.622,0,0,1,2.79-1.9A6.857,6.857,0,0,1,11.08,0a7.524,7.524,0,0,1,3.879,1.258,8.26,8.26,0,0,1,3.193,3.768A13.461,13.461,0,0,1,19.287,10.6a14.464,14.464,0,0,1-.643,4.463,9.794,9.794,0,0,1-1.931,3.45,9.67,9.67,0,0,1-2.673,2.206,6.051,6.051,0,0,1-2.862.735,6.176,6.176,0,0,1-2.51-.559,15.047,15.047,0,0,1-3.192-2.167v10.7ZM9.606,4.552a5.342,5.342,0,0,0-1.888.392A12.128,12.128,0,0,0,5.476,6.117v9.009a9.933,9.933,0,0,0,2.192,1.2,5.7,5.7,0,0,0,2.016.4,3.749,3.749,0,0,0,2.956-1.481c.817-.978,1.232-2.593,1.232-4.8A6.689,6.689,0,0,0,12.61,6.031,3.846,3.846,0,0,0,9.606,4.552Z"
          transform="translate(42.279 8.453)"
          fill="#a7a8aa"
        />
        <path
          id="Fill_3"
          data-name="Fill 3"
          d="M2.459,37.891H0V34.167a5.475,5.475,0,0,0,3.243-.77,2.773,2.773,0,0,0,.832-2.216V8.807H9.49V31.92a6.291,6.291,0,0,1-.711,3.061,5.237,5.237,0,0,1-2.336,2.1A8.908,8.908,0,0,1,2.459,37.891ZM9.49,5.321H4.075V0H9.49V5.32Z"
          transform="translate(60.168 0)"
          fill="#a7a8aa"
        />
        <path
          id="Fill_5"
          data-name="Fill 5"
          d="M5.416,4.432A16.617,16.617,0,0,1,9.393.923,7.069,7.069,0,0,1,12.862,0a4.845,4.845,0,0,1,3.276,1.009,6.49,6.49,0,0,1,1.708,3.613A21.434,21.434,0,0,1,22.126.8,6.828,6.828,0,0,1,25.487,0a5.246,5.246,0,0,1,2.668.582,4.391,4.391,0,0,1,1.632,1.8,10,10,0,0,1,.879,4.68L30.727,21.1H25.313V7.9a4.253,4.253,0,0,0-.674-2.731A2.283,2.283,0,0,0,22.8,4.374,3.776,3.776,0,0,0,20.824,5a13.88,13.88,0,0,0-2.752,2.625V21.1H12.655V8.151a4.875,4.875,0,0,0-.712-3,2.122,2.122,0,0,0-1.695-.893A4.127,4.127,0,0,0,7.872,5.1,11.066,11.066,0,0,0,5.416,7.657V21.1H0V.355H5.416Z"
          transform="translate(73.28 8.453)"
          fill="#a7a8aa"
        />
        <path
          id="Fill_7"
          data-name="Fill 7"
          d="M14.659,28.489a15.038,15.038,0,0,1-4.341-.636l9.585-.306A14.971,14.971,0,0,1,14.659,28.489Zm7.3-1.89-15.42-.492c-.249-.162-.449-.3-.63-.43L24.155,25.1a14.948,14.948,0,0,1-2.192,1.5Zm3-2.223h0L3.7,23.7c-.086-.093-.162-.179-.234-.263L26.454,22.7a14.28,14.28,0,0,1-1.492,1.671Zm1.913-2.255L1.937,21.326c-.027-.043-.051-.087-.077-.134l-.012-.021,26.063-.829a13.829,13.829,0,0,1-1.036,1.777Zm1.267-2.276L.829,18.974l-.016-.041L.8,18.888,28.806,18a14.374,14.374,0,0,1-.664,1.846Zm.78-2.293L.2,16.636c0-.006,0-.013,0-.02s0-.017,0-.026l29.05-.926a14.24,14.24,0,0,1-.326,1.886Zm.36-2.306L0,14.313V14.28l29.289-.932c.019.3.029.607.029.9,0,.331-.012.667-.036,1h0Zm-.025-2.317L.18,12c0-.009,0-.017,0-.026s0-.012,0-.019l28.759-.917a13.887,13.887,0,0,1,.31,1.886ZM28.833,10.6.759,9.7l.02-.054.011-.03,27.4-.873a13.741,13.741,0,0,1,.646,1.848Zm-.871-2.346L1.787,7.419,1.8,7.4l.08-.135,25.069-.8a14.582,14.582,0,0,1,1.017,1.78h0ZM26.532,5.89h0L3.373,5.152c.093-.108.162-.186.224-.254l21.47-.684a14.359,14.359,0,0,1,1.465,1.675ZM24.285,3.5h0L5.776,2.912c.216-.159.412-.3.6-.419l15.758-.5A14.622,14.622,0,0,1,24.284,3.5ZM20.2,1.054,10.015.731A15.1,15.1,0,0,1,20.2,1.053Z"
          transform="translate(5.077 4.473)"
          fill="#003a5d"
        />
        <path
          id="Fill_9"
          data-name="Fill 9"
          d="M11.283,27.839C10.5,27.278,9.7,26.58,9.7,26.58l-.157-4.156a16.087,16.087,0,0,1-2.65,3.054c-1.182.88-3.735.806-5.047.358S0,20.541,0,20.541l3.509-.174.616,2.956,4.883-5.436-.318-2.2,1.422-.875-.037-1.453,4.041.569-.446,3.824s.912,2.106,1.569,2.04S23.632,5.9,23.632,5.9L22.874,0s1.182.077,2.982.345S28.84.9,28.84.9s-.109,7.31-.121,9.761c-.018,2.862.85,7.9,4.026,8.081S51.6,1.975,51.6,1.975,37.584,19.826,34.844,20.543s-7.685-2.6-7.685-2.6L26.2,28.97a10.717,10.717,0,0,1-1.215.537,8.61,8.61,0,0,1-1.627.485l.1-17.672s-2.684,8.76-5.015,9.3a11.653,11.653,0,0,1-5.192-.359L13,28.851a14.6,14.6,0,0,1-1.713-1.012"
          transform="translate(0 2.514)"
          fill="#003a5d"
        />
        <g
          id="Group_13"
          data-name="Group 13"
          transform="translate(105.876 8.579)"
        >
          <path
            id="Clip_12-2"
            data-name="Clip 12"
            d="M0,0H3.281V3.186H0Z"
            transform="translate(0 0)"
            fill="none"
          />
          <g
            id="Group_13-2"
            data-name="Group 13"
            transform="translate(0 0)"
            clipPath="url(#clip-path)"
          >
            <path
              id="Fill_11"
              data-name="Fill 11"
              d="M1.641,3.186A1.619,1.619,0,0,1,0,1.593,1.62,1.62,0,0,1,1.641,0a1.619,1.619,0,0,1,1.64,1.593A1.619,1.619,0,0,1,1.641,3.186Zm0-2.972a1.367,1.367,0,0,0-.983.4,1.38,1.38,0,0,0-.392.978,1.379,1.379,0,0,0,.392.977,1.367,1.367,0,0,0,.983.4,1.364,1.364,0,0,0,.982-.4,1.38,1.38,0,0,0,.392-.977A1.381,1.381,0,0,0,2.623.615,1.364,1.364,0,0,0,1.641.214ZM1.295,2.544H1.03V.648h.748c.425,0,.632.171.632.524a.516.516,0,0,1-.451.529l.543.841H2.2L1.672,1.7H1.295v.842Zm0-1.681v.622h.365a.846.846,0,0,0,.333-.044.267.267,0,0,0,.153-.273c0-.27-.227-.3-.425-.3Z"
              transform="translate(0 0)"
              fill="#a7a8aa"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default PJMFooterLogo